import { IconButton } from '@mui/material'
import BaseWidgetProvider from './base/BaseWidgetProvider'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

const WidgetBack = () => {
  return (
    <IconButton
      sx={{
        width: '100%',
        height: '100%'
      }}
      disableRipple
    >
      <ArrowBackIcon />
    </IconButton>
  )
}

class WidgetBackProvider extends BaseWidgetProvider {
  getCode = () => 'WidgetBack'

  getName = () => 'Back'

  getIcon = () => ArrowBackIcon

  createWidget = (props) => <WidgetBack {...props} />

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight), availableWithoutDevice: true, hideHeader: true }
  }

  onClick = (props) => props.navigateToDeviceId()

  isClickable = () => true
}

export default WidgetBackProvider
